"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var grid_query_1 = require("./grid-query");
var utils_1 = require("../common/utils");
/**
 * @hidden
 */
exports.exportElement = function (wrapper) {
    var query = new grid_query_1.GridQuery(wrapper);
    var content = query.content();
    var result;
    if (content) {
        var colGroups = [content.querySelector('colgroup')];
        var headers = [query.header().querySelector('thead')];
        var bodies = [content.querySelector('tbody')];
        var footer = query.footer();
        var footers = footer ? [footer.querySelector('tfoot')] : [];
        result = utils_1.createTable(colGroups, headers, bodies, footers);
    }
    else {
        result = utils_1.wrapTable(query.table().cloneNode(true));
    }
    return result;
};
//# sourceMappingURL=export-element.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@progress/kendo-react-pdf/dist/npm/grid/export-element.js
// module id = 837
// module chunks = 0